import React, { useEffect, useState } from "react";
import "./Ajuda.css";

const Ajuda = () => {
  const [usuario, setUsuario] = useState({ nome: "", email: "" });
  const [mensagem, setMensagem] = useState("");
  const [activeCategory, setActiveCategory] = useState(null);

  // Busca os dados do usuário no backend
  useEffect(() => {
    fetch("https://welaunchyou.com.br/crm-wly/getUser.php", {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.error) {
          setUsuario({ nome: data.nome, email: data.email });
        }
      })
      .catch((error) => console.error("Erro ao buscar usuário:", error));
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("nome", usuario.nome);
    formData.append("email", usuario.email);
    formData.append("mensagem", mensagem);

    const response = await fetch("https://welaunchyou.com.br/crm-wly/enviar_suporte.php", {
      method: "POST",
      body: formData,
    });

    if (response.ok) {
      alert("Mensagem enviada com sucesso!");
      setMensagem("");
    } else {
      alert("Erro ao enviar mensagem.");
    }
  };

  const toggleCategory = (category) => {
    setActiveCategory(activeCategory === category ? null : category);
  };

  return (
    <div className="ajuda-titulo">
    <h1 style={{ borderBottom: "none" }}>Ajuda e Suporte</h1>

    <div className="container-ajuda">
      <section className="faq">
        <h2 style={{ borderBottom: "none" }}>Perguntas Frequentes</h2>

        {/* SOBRE AS AÇÕES */}
        <div className="faq-category">
          <h3 onClick={() => toggleCategory("acoes")} className="faq-title">
            Sobre as Ações {activeCategory === "acoes" ? "▲" : "▼"}
          </h3>
          {activeCategory === "acoes" && (
            <div className="faq-content">
              <div className="faq-item"><h4><b>Como criar uma nova ação para um lead?</b></h4><p><b>Forma 01:</b> Vá até o menu Ações, Clique em Criar Ação. Selecione o Lead que quer criar uma nova ação, preencha os dados e clique em Criar Ação.</p>
              <p><b>Forma 02:</b> Clique no menu Leads e na sequência clique em Listagem de Leads. Você pode filtrar o lead desejado pelos filtros ou encontrá-lo na lista abaixo do formulário. Ao encontrar o lead, clique no botão azul na direita do nome do Lead, chamado Criar Ação.</p></div>
              <div className="faq-item"><h4><b>Como visualizar as ações já criadas?</b></h4><p>Vá até o menu Ações e clique em Ações. Lá você pdoerá visualizar todas as ações criadas ou filtrar pelo período desejado.</p></div>
              <div className="faq-item"><h4><b>Como marcar uma ação como Concluída?</b></h4><p>Vá até o menu Ações e clique em Listagem de Ações. Lá você pdoerá visualizar todas as ações criadas ou filtrar pelo período desejado. Ao encontrar a ação desejada, clique no botão azul Marcar como Concluída.</p></div>
              <div className="faq-item"><h4><b>É possível modificar uma Ação?</b></h4><p>Sim, é possível. Clique no menu Ações, em seguida clique em Listagem de Ações. Filtre a ação desejada ou encontre na lista abaixo. Ao encontrar clique no botão Editar, faça a alteração necessária e clique em Salvar. </p></div>
            </div>
          )}
        </div>

        {/* SOBRE AS OBJEÇÕES */}
        <div className="faq-category">
          <h3 onClick={() => toggleCategory("objecoes")} className="faq-title">
            Sobre as Objeções {activeCategory === "objecoes" ? "▲" : "▼"}
          </h3>
          {activeCategory === "objecoes" && (
            <div className="faq-content">
              <div className="faq-item"><h4><b>Como criar uma Objeção?</b></h4><p>Vá até o menu Ações, em seguida clique no link Criar Ação / Objeção. No formulário descreva qual ação foi executada com o lead previamente selecionado, coloque a data e em seguida escolha uma objeção que se encaixe com seu Lead. Após o preenchimento clique no botão Criar.</p></div>
              <div className="faq-item"><h4><b>Posso alterar uma Objeção?</b></h4><p>Sim, basta ir até o menu Ações, procurar por Listagem de Ações. Escolha o lead no filtro ou procure na lista completa abaixo. Ao achar a Ação que tem a Objeçao a ser alterada, clique no botão Editar.<br></br> Pronto! Basta Editar a Objeção e depois clicar em Salvar.</p></div>
            </div>
          )}
        </div>

        {/* SOBRE OS LEADS */}
        <div className="faq-category">
          <h3 onClick={() => toggleCategory("leads")} className="faq-title">
            Sobre os Leads {activeCategory === "leads" ? "▲" : "▼"}
          </h3>
          {activeCategory === "leads" && (
            <div className="faq-content">
              <div className="faq-item"><h4><b>Como cadastrar um novo lead?</b></h4><p>Acesse o menu lateral Leads e em seguida Cadastrar Lead, preencha as informações obrigatórias e clique no botão Salvar.</p></div>
              <div className="faq-item"><h4><b>Como visualizar as informações de um Lead?</b></h4><p>Acesse o menu lateral Leads e em seguida Listagem de Leads, filtre o lead desejado pelo filtro ou encontre na lista abaixo. Ao localizar o lead, basta clicar no botão azul Detalhes.</p></div>
              <div className="faq-item"><h4><b>Como editar as informações de um Lead?</b></h4><p>Acesse o menu lateral Leads e em seguida Listagem de Leads, filtre o lead desejado pelo filtro ou encontre na lista abaixo. Ao localizar o lead, basta clicar no botão azul Editar. Após editar as informações desejadas basta clicar em Atualizar.</p></div>
            </div>
          )}
        </div>

        {/* SOBRE OS RELATÓRIOS */}
        <div className="faq-category">
          <h3 onClick={() => toggleCategory("relatorios")} className="faq-title">
            Sobre os Relatórios {activeCategory === "relatorios" ? "▲" : "▼"}
          </h3>
          {activeCategory === "relatorios" && (
            <div className="faq-content">
              <div className="faq-item"><h4><b>Como gerar Relatórios? </b></h4><p>Para gerar um relatório, basta acessar o menu Dados e em seguida clicar em Relatórios. Ao carregar a pagina o Nórea CRM trará as informações de todo o período de dados.</p></div>
              <div className="faq-item"><h4><b>Como gerar Relatórios por período específico?</b></h4><p>Para gerar um relatório por período específico, basta acessar o menu Dados e em seguida clicar em Relatórios. Ao carregar a pagina, na parte superior, haverá um filtro, onde será possível escolher qual período deseja que o relatório leva em consideração, ou também botões com intervalos de tempo padrões.</p></div>
              <div className="faq-item"><h4><b>Como exportar Dados do Relatório?</b></h4><p>Acesse o menu lateral Dados, em seguida clique em Exportar Dados. No formulário escolha a opção de qual dado quer exportar, na sequencia escolha o período inicial e final que deseja, e por fim escola o formato do arquivo que quer exportar, clique em Exportar para fazer o download.</p></div>
              <div className="faq-item"><h4><b>Quais formatos posso exportar?</b></h4><p>É possível exportar em CSV, EXCEL e PDF.</p></div>
            </div>
          )}
        </div>

        {/* PERGUNTAS GERAIS */}
        <div className="faq-category">
          <h3 onClick={() => toggleCategory("geral")} className="faq-title">
            Perguntas Gerais {activeCategory === "geral" ? "▲" : "▼"}
          </h3>
          {activeCategory === "geral" && (
            <div className="faq-content">
              <div className="faq-item"><h4><b>Como recuperar minha senha?</b></h4><p>Na página de login, clique em "Esqueci minha senha".</p></div>
              <div className="faq-item"><h4><b>Como alterar minha senha?</b></h4><p>Clique no menu Configurações, em seguida clique em Alterar Senha. Preencha os dados e depois clique no botão Alterar Senha.</p></div>
              <div className="faq-item"><h4><b>Como modificar meus dados no Nórea CRM?</b></h4><p>Clique no menu Configurações, em seguida clique em Meus Dados. Altere o que for necessário no formulário e clique no botão Salvar.</p></div>
            </div>
          )}
        </div>
      </section>

      <section className="support-form">
        <h2>Não Encontrou sua Dúvida? Contate o Suporte</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label>Nome:</label><input type="text" value={usuario.nome} readOnly /></div>
          <div className="form-group"><label>E-mail:</label><input type="email" value={usuario.email} readOnly /></div>
          <div className="form-group"><label>Mensagem:</label><textarea value={mensagem} onChange={(e) => setMensagem(e.target.value)} required></textarea></div>
          <button type="submit">Enviar</button>
        </form>
      </section>
    </div>
    </div>
  );
};

export default Ajuda;
